/**
 * orga-app-api - kontaktverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface KontaktTelefon { 
    modified_on_utc?: Date;
    kontakt_id: string;
    kontakt_telefon_id: string;
    label?: string;
    telefon?: string;
    modified_user_id?: string;
}

